// @module BluePoint.AddressBookSearch.AddressBookSearch
define('BluePoint.AddressBookSearch.AddressBookSearch.View'
,	[
		'bluepoint_addressbooksearch_addressbooksearch.tpl'

	// ,	'Address.Collection'
	
	,	'Backbone'

	,	'jQuery'
    ]
, function (
		bluepoint_addressbooksearch_addressbooksearch_tpl

	// ,	AddressCollectionModule
	
	,	Backbone

	,	$
)
{
    'use strict';

	// @class BluePoint.AddressBookSearch.AddressBookSearch.View @extends Backbone.View
	return Backbone.View.extend({

		template: bluepoint_addressbooksearch_addressbooksearch_tpl

	,	initialize: function (options) {

            this.container = options.container;

			// var AddressCollection = AddressCollectionModule.AddressCollection || AddressCollectionModule;
            // this.addressCollection = new AddressCollection();
            // var self = this;

            // // Fetch from backend
            // this.addressCollection.fetch().done(function () {
            //     console.log('Addresses Loaded:', self.addressCollection.toJSON());
            //     self.render();
            // });
		}

	,	events: {
            'keyup #addressSearchInput': 'filterAddresses'
		}

    ,   filterAddresses: function (e) {
            var value = $(e.currentTarget).val().toLowerCase().trim();

			// Select all address blocks
            var $addresses = $('.address-details-container');

            // Loop and toggle based on ZIP or text content
            $addresses.each(function () {
                var $this = $(this);
                var text = $this.text().toLowerCase(); // full text inside container
                var zip = $this.find('.address-zip').text().toLowerCase(); // if ZIP is in specific element

                // Match either full text or zip
                if (text.indexOf(value) > -1 || zip.indexOf(value) > -1) {
                    $this.closest('.backbone-collection-view-cell-span4').show();
                    $this.closest('.order-wizard-address-cell4').show();
                } else {
                    $this.closest('.backbone-collection-view-cell-span4').hide();
                    $this.closest('.order-wizard-address-cell4').hide();
                }
            });
        }

		//@method getContext @return BluePoint.AddressBookSearch.AddressBookSearch.View.Context
	,	getContext: function getContext()
		{
			return {

			};
		}
	});
});
